import {
  Component,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  Input,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DxButtonModule,
  DxListModule,
  DxToolbarModule,
} from 'devextreme-angular';
import DataSource from 'devextreme/data/data_source';
import { OrtakService } from '../services/ortak.service';
import { UtilsService } from '../services/utils.service';
import { sanitizeHtml } from '../services/html-sanitize';
import { GenBildirimService } from './gen-bildirim.service';
import { FormHeaderComponent } from '../components/components';
import { DkNavService } from '../services/dk-nav.service';
import { GetFormMetadata_Request } from '../models/ortak.dtos';
import { Subscription, take } from 'rxjs';
import { RealtimeService } from '../services/realtime.service';
import { Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {
  GetResim_Request,
  ImageResponse,
  ResimSourceType,
} from '../../../../../../libs/gen/src/lib/models/genpg.models';
import { GenOrtManuelService } from 'libs/gen/src/lib/services/moduls-manuel-services/ort/gen-ort-manuel.service';

@Component({
  selector: 'dk-gen-bildirim',
  standalone: true,
  imports: [
    CommonModule,
    DxListModule,
    DxToolbarModule,
    DxButtonModule,
    FormHeaderComponent,
  ],
  templateUrl: './gen-bildirim.component.html',
  styleUrls: ['./gen-bildirim.component.scss'],
})
export class GenBildirimComponent {
  @ViewChild('listRef', { static: false }) listRef: any;
  @ViewChild('panel') popupPanelRef!: ElementRef;

  selectRow: any;
  showBackToTopButton = false;
  dataSource: DataSource;

  visible = false;
  genBildirimValue: any;

  eventHandler = (event: CustomEvent) => {
    const eventData = event.detail;
    if (eventData.close) {
      this.visible = false;
      this.genBildirimValue = eventData;
      this.changeDS();
    } else {
      this.visible = true;
      this.genBildirimValue = eventData;
      this.changeDS();
    }
  };

  public initialized = false;
  private imageUpdateTimeout: any;

  readAllClick = () => this.allRead();
  deleteAllClick = () => this.allDelete();

  constructor(
    private ortakService: OrtakService,
    public genBildirimService: GenBildirimService,
    private utilsService: UtilsService,
    private navService: DkNavService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private ortManuelService: GenOrtManuelService,
    private realtime: RealtimeService
  ) {}
  private bildirimAbonelik?: Subscription;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['genBildirimValue'] && this.genBildirimValue) {
      if (
        this.genBildirimValue.value ===
        changes['genBildirimValue'].currentValue.value
      ) {
        this.genBildirimValue = changes['genBildirimValue'].currentValue;
        this.changeDS();
      }
    }
  }

  ngOnInit() {
    window.addEventListener(
      'genBildirimEvent',
      this.eventHandler as EventListener
    );
    // Panel açıkken yeni bildirim gelirse liste tazelenir (önceden yalnız panel açılırken yükleniyordu)
    this.bildirimAbonelik = this.realtime.bildirim$.subscribe(() => {
      if (this.visible && this.genBildirimValue?.value === 'GenBildirim') this.changeDS();
    });
  }
  ngOnDestroy() {
    this.bildirimAbonelik?.unsubscribe();
    window.removeEventListener(
      'genBildirimEvent',
      this.eventHandler as EventListener
    );
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initialized = true;
      document.addEventListener('click', this.handleClickOutside, true); // useCapture = true
    }, 100);
  }

  changeDS() {
    switch (this.genBildirimValue.value) {
      case 'Telefon':
        this.dataSource = this.genBildirimService.getData(
          'vBimPersonelTelefonDetay',
          'Gorev'
        );
        break;
      case 'İzin':
        const ds = this.genBildirimService.getData(
          'vIkaIzinliPersonelList',
          ''
        );

        // Reload data source to get fresh data from server
        ds.reload().then(async (data: any[]) => {
          // Initialize items without images first
          const dataWithPlaceholders = data.map(item => ({
            ...item,
            imageBase64: null, // Will be loaded asynchronously
          }));

          // Create DataSource immediately with data (without waiting for images)
          this.dataSource = new DataSource({
            store: dataWithPlaceholders,
            group: 'GorevBirimAd',
            searchExpr: [
              'AdSoyad',
              'PersonelKod',
              'BaslangicTarih',
              'BitisTarih',
              'GorevBirimAd',
              'GorevBirimKod',
            ],
            searchOperation: 'contains',
          });

          // Load images asynchronously and update items as they load
          data.forEach(async (item, index) => {
            try {
              const resim = await this.ortManuelService.GetResim_Request(
                new GetResim_Request({
                  resimKod: item.PersonelKod,
                  sourceType: ResimSourceType.personel,
                  base64Yn: 1,
                })
              );
              
              // Update the item directly in the array
              if (this.dataSource && resim?.response?.base64 && dataWithPlaceholders[index]) {
                dataWithPlaceholders[index].imageBase64 = resim.response.base64;
                // Debounce reload to avoid too many updates
                if (this.imageUpdateTimeout) {
                  clearTimeout(this.imageUpdateTimeout);
                }
                this.imageUpdateTimeout = setTimeout(() => {
                  if (this.dataSource) {
                    this.dataSource.reload();
                  }
                }, 100); // Reload after 100ms of no new image updates
              }
            } catch (error) {
              console.error(`Error loading image for personel ${item.PersonelKod}:`, error);
            }
          });
        });
        break;

      case 'GenBildirim':
        this.dataSource = this.genBildirimService.getGenBildirimData();
        break;
      case 'Duyuru':
        this.dataSource = this.genBildirimService.getData('GenDuyuru', '', [
          ['YayinlaEh', '=', 'E'],
        ]);
        break;
      default:
        break;
    }
  }

  selectedItem: any = null;
  safeHtmlContent: SafeHtml | null = null;

  onItemClick(e: any) {
    this.selectedItem = e.itemData;
    this.safeHtmlContent = sanitizeHtml(this.sanitizer, this.selectedItem.DuyuruMetin);
  }

  private handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement;

    const isInsidePopup = this.popupPanelRef?.nativeElement.contains(target);
    const isInsideDevextremePopup = !!target.closest(
      '.dx-overlay-wrapper, .dx-popup-wrapper, .dx-overlay-content'
    );
    const isInsideDxButton = !!target.closest('.dx-button');

    if (!isInsidePopup && !isInsideDevextremePopup && !isInsideDxButton) {
      this.visible = false;
      const closeEvent = { close: true };
      window.dispatchEvent(
        new CustomEvent('genBildirimEvent', { detail: closeEvent })
      );
    }
  };

  handleScroll(e: any) {
    const scrollEl = e.event.target;
    this.showBackToTopButton = scrollEl.scrollTop > 200;
  }

  scrollToTop() {
    const listContainer = this.listRef
      .element()
      .querySelector('.dx-scrollable-container');
    if (listContainer) {
      listContainer.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  handleCancelClick() {
    this.visible = false;
    const closeEvent = { close: true };
    window.dispatchEvent(
      new CustomEvent('genBildirimEvent', { detail: closeEvent })
    );
  }

  onSelectionChanged(e: any) {
    this.selectRow = e.addedItems[0];
  }

  openForm(item: any) {
    this.selectRow = item;

    if (this.selectRow && this.selectRow.OkunduEh !== 'E') {
      const requestType = {
        Kod: this.selectRow.Kod,
        TumuEH: 'H',
        silEH: 'H',
      };
      this.genBildirimService.bildirimRequest(requestType);
    }

    if (this.selectRow.FormAd) {
      // eski hâli (07.10.2026): servisteki BehaviorSubject'ten take(1) — yeni yanıt gelmeden ÖNCEKİ değeri okuyordu
      // (ilk tıklamada null → hiçbir şey açılmıyor; sonrakilerde bir önceki bildirimin form başlığı).
      // this.genBildirimService.getFormMetaData(
      //   new GetFormMetadata_Request({ formAd: this.selectRow.FormAd })
      // );
      //
      // this.genBildirimService.genBildirimMetadata$
      //   .pipe(take(1))
      //   .subscribe((formData) => {
      //     if (formData) {
      this.ortakService
        .getFormMetadata(new GetFormMetadata_Request({ formAd: this.selectRow.FormAd, altFormAd: '', kod: 0, logYn: false }))
        .pipe(take(1))
        .subscribe((res) => {
          const formData = res?.formMetadata;
          if (formData || DkNavService.bilinenBaslik(this.selectRow.FormAd)) {
            this.navService.pages$.pipe(take(1)).subscribe((pages) => {
              const existingPage = pages.find(
                (page:any) => page?.path === this.selectRow.FormAd
              );
              if (existingPage) {
                this.navService.closeButtonHandler(existingPage);
              }
              if (this.router.url != '/main/dabnet') {
                this.router.navigate(['/main/dabnet']);
              }
              this.navService.addButtonHandler({
                path: this.selectRow.FormAd,
                // eski hâli (07.10.2026): text: formData.formTitle,  — GEN_FORM'da başlığı olmayan sekmede (Görevlerim) boş kalıyordu
                text: formData?.formTitle || DkNavService.bilinenBaslik(this.selectRow.FormAd) || this.selectRow.Baslik,
                data: { sendedData: { Kod: this.selectRow.ItemKod } },
              });

              this.visible = false;
              const closeEvent = { close: true };
              window.dispatchEvent(
                new CustomEvent('genBildirimEvent', { detail: closeEvent })
              );
            });
          }
        });
    }
  }

  allDelete() {
    const requestType = { TumuEH: 'E', silEH: 'E' };
    this.genBildirimService.bildirimRequest(requestType).then((res) => {
      if (res.response?.result) {
        this.utilsService.showSuccess('Tüm bildirimler silindi', 'Başarılı');
      }
    });
  }

  allRead() {
    const requestType = { TumuEH: 'E', silEH: 'H' };
    this.genBildirimService.bildirimRequest(requestType).then((res) => {
      if (res.response?.result) {
        this.utilsService.showSuccess('Tüm bildirimler okundu', 'Başarılı');
      }
    });
  }

  oneDelete(item: any) {
    const requestType = {
      Kod: item.Kod,
      TumuEH: 'H',
      silEH: 'E',
    };
    this.genBildirimService.bildirimRequest(requestType).then((res) => {
      if (res.response?.result) {
        this.utilsService.showSuccess('Bildirim silindi', 'Başarılı');
        const store = this.dataSource.store();
        store.push([
          {
            type: 'remove',
            key: item.Kod,
          },
        ]);
      }
    });
  }

  oneRead(item: any) {
    if (item?.OkunduEh !== 'E') {
      const requestType = {
        Kod: item.Kod,
        TumuEH: 'H',
        silEH: 'H',
      };
      this.genBildirimService.bildirimRequest(requestType).then((res) => {
        if (res.response?.result) {
          const store = this.dataSource.store();
          store.push([
            {
              type: 'update',
              key: item.Kod,
              data: { ...item, OkunduEh: 'E' },
            },
          ]);
        }
      });
    }
  }
}
